import { VerificationServiceConfiguration, FormattedVerificationServiceConfiguration } from "@idw-types/data/verification-service-configuration/verification-service-configuration";
import { AxnCompany, AxnRelyingParty, SimpleAxnWorkflow } from "@idw-types/data/reference-data/axn";
import { RpServiceType } from "@idw-types/data/reference-data/generic";
import { isAllowedToRestore } from "@utils/data-util";

export const formatVerificationServiceConfigurations = (
    verificationServiceConfigurations: Array<VerificationServiceConfiguration>,
    companies: Array<AxnCompany>,
    relyingParties: Array<AxnRelyingParty>,
    rpServiceTypes: Array<RpServiceType>,
    simpleAXNWorkflows: Array<SimpleAxnWorkflow>,
    simpleAXNAdminWorkflows: Array<SimpleAxnWorkflow>
): Array<FormattedVerificationServiceConfiguration> => {
    return verificationServiceConfigurations.map(verificationServiceConfiguration => formatVerificationServiceConfiguration(
        verificationServiceConfiguration,
        companies,
        relyingParties,
        rpServiceTypes,
        simpleAXNWorkflows,
        simpleAXNAdminWorkflows
    ));
};

export const formatVerificationServiceConfiguration = (
    verificationServiceConfiguration: VerificationServiceConfiguration,
    companies: Array<AxnCompany>,
    relyingParties: Array<AxnRelyingParty>,
    rpServiceTypes: Array<RpServiceType>,
    simpleAXNWorkflows: Array<SimpleAxnWorkflow>,
    simpleAXNAdminWorkflows: Array<SimpleAxnWorkflow>
): FormattedVerificationServiceConfiguration => {
    let company: AxnCompany;
    const relyingParty = relyingParties.find(rp => rp.id === verificationServiceConfiguration.relyingPartyID);
    if (relyingParty) {
        company = companies.find(c => c.id === relyingParty.companyID);
    }
    const rpServiceType = rpServiceTypes.find(serviceType => serviceType.key === verificationServiceConfiguration.serviceType);
    let workflow = simpleAXNAdminWorkflows.find(workflow => workflow.id === verificationServiceConfiguration.workflowID);
    if (!workflow) {
        workflow = simpleAXNWorkflows.find(workflow => workflow.id === verificationServiceConfiguration.workflowID);
    }

    let lastModifiedDate = null;
    if (verificationServiceConfiguration.lastModifiedDate) {
        lastModifiedDate = new Date(parseInt(verificationServiceConfiguration.lastModifiedDate));
    }

    let lastDeploymentDate = null;
    if (verificationServiceConfiguration.lastDeploymentDate) {
        lastDeploymentDate = new Date(parseInt(verificationServiceConfiguration.lastDeploymentDate));
    }

    return {
        apiKey: verificationServiceConfiguration.apiKey,
        changeRequestID: verificationServiceConfiguration.changeRequestID,
        changeRequestStatus: verificationServiceConfiguration.changeRequestStatus,
        changeRequestType: verificationServiceConfiguration.changeRequestType,
        deployed: verificationServiceConfiguration.deployed,
        id: verificationServiceConfiguration.id,
        lastModifiedDate: lastModifiedDate,
        lastDeploymentDate: lastDeploymentDate,
        permissions: {
            ...verificationServiceConfiguration.permissions,
            canRestore: isAllowedToRestore(
                verificationServiceConfiguration.permissions.canRestore,
                relyingParty.status,
                company.status)
        },
        policyConfigID: verificationServiceConfiguration.policyConfigID,
        relyingParty: relyingParty,
        selectedPolicyID: verificationServiceConfiguration.selectedPolicyID,
        serviceName: verificationServiceConfiguration.serviceName,
        rpServiceType: rpServiceType,
        simpleAXNWorkflow: workflow,
        company: company,
        status: verificationServiceConfiguration.status
    };
}